import { render, staticRenderFns } from "./Video-Player.vue?vue&type=template&id=34a4d94f&scoped=true"
import script from "./Video-Player.vue?vue&type=script&lang=js"
export * from "./Video-Player.vue?vue&type=script&lang=js"
import style0 from "./Video-Player.vue?vue&type=style&index=0&id=34a4d94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a4d94f",
  null
  
)

export default component.exports